export const cleanUndefineds = (originalArray) => {
    let targetArray = [];

    for (let i = 0; i < originalArray.length; i++) {
        if (originalArray[i]) {
            targetArray.push(originalArray[i]);
        }
    }

    return targetArray;
}

export const getFilteredArray = (originalArray, conditionsObject, conditionKey = "id") => {
    if (JSON.stringify(conditionsObject) !== JSON.stringify({})) {
        let filteredArray = [];

        for (let i = 0; i < originalArray.length; i++) {
            if (conditionsObject[originalArray[i][conditionKey]]) { filteredArray.push(originalArray[i]); }
        }

        return filteredArray;
    }
    else {
        return originalArray;
    }
}

export const flipArray = (originalArray) => {
    let targetArray = [];
    for (let i = originalArray.length - 1; i >= 0; i--) { targetArray.push(originalArray[i]); }
    return targetArray;
}